import {
  HEIGHT_PARAM,
  OPTIONS_PARAM,
  ROUTE_MAP,
  WIDTH_PARAM,
  DOCUMENT_TITLES,
  CHECKOUT_TITLE,
} from 'utils/globals';

import type { AppDispatch } from 'store/wos_store';
import type { NavigateThunk, NavigationRoute, NavigationRouteMap } from 'domains/navigation';

export function buildConfiguredURL(
  url: URL,
  root: string,
  configPath?: string,
  configParams?: string,
  customSizeParam?: string
) {
  const updateURL = new URL(url);
  const urlParams = new URLSearchParams(url.search);

  if (configPath) {
    updateURL.pathname = `${root}${configPath}`;
  }

  if (configParams) {
    urlParams.set(OPTIONS_PARAM, configParams);
  } else {
    urlParams.delete(OPTIONS_PARAM);
  }

  if (customSizeParam) {
    new URLSearchParams(customSizeParam).forEach((value, param) => urlParams.set(param, value));
  } else {
    urlParams.delete(HEIGHT_PARAM);
    urlParams.delete(WIDTH_PARAM);
  }

  updateURL.search = urlParams.toString();
  return updateURL;
}

function findRouteNameByRootPath(root: string) {
  let routeName: NavigationRoute = 'catalogSelector';

  const routeEntries = Object.entries(ROUTE_MAP) as [NavigationRoute, string][];

  routeEntries.forEach(([name, path]) => {
    const pathStr = path.split('/').filter((p) => !!p)[0];

    if (pathStr === root) {
      routeName = name;
    }
  });

  return routeName;
}

// Decides how to dispatch navigation if product configuration changes
export function handleConfigurationRouteChange(
  configChange: string,
  dispatch: AppDispatch,
  actionCreator: NavigateThunk
) {
  const root = window.location.pathname.split('/').filter((path) => !!path)[0];
  if (configChange !== '' && (root === 'price-tool' || root === 'c')) {
    const route = findRouteNameByRootPath(root);
    dispatch(actionCreator(route));
  }
}

export function updateDocumentTitle(route: keyof NavigationRouteMap | 'checkout') {
  const current = window.document.title.split('|');
  let title: string | undefined;

  if (route === 'checkout') {
    title = CHECKOUT_TITLE;
  } else {
    title = DOCUMENT_TITLES[route];
  }

  if (title) {
    current[0] = `${title} `;
    window.document.title = current.join('|');
  }
}
